import { Box, styled } from '@mui/material';

const DateRangeWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 424px;
`;

export default DateRangeWrapper;
